'use strict'

module.exports = text

/* Stringify `text`. */
function text(ctx, node, index, parent) {
  var value = node.value

  return value
}
